/**
 * Calculate the scroll bar width of the browser
 */
export function getScrollbarWidth() {
	let outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

	document.body.appendChild(outer);

	let widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	let inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	let widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	return widthNoScroll - widthWithScroll;
}

/**
 * Get the browsers current viewport width
 */
export function getViewportWidth() {
	return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

/**
 * Get the browsers current viewport height
 */
export function getViewportHeight() {
	return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

/**
 * Function to debounce a function if run in quick successtion. If the function is called again before the timer ends it will clear it's. Only until
 * after the delay has expired will the func(tion) passed be called
 *
 * @param {Function} func - the function to run after debouncing
 * @param {object} timer - object with the timers
 * @param {string} key - the timer key to use
 * @param {int} delay - the delay in ms
 */
export function _debounce(fn, time) {
	let timeout;
	return function () {
		const functionCall = () => fn.apply(this, arguments);

		clearTimeout(timeout);
		timeout = setTimeout(functionCall, time);
	};
}

/**
 * Determine if passed variable is a function
 *
 * @param {*} func
 */
export function isFunction(func) {
	return func && {}.toString.call(func) === '[object Function]';
}

/**
 * Calculate theme breakpoints
 */
export function calcBreakpoints() {
	if (undefined === hpy_sizes) {
		return;
	}

	hpy_sizes.height = getViewportHeight();
	hpy_sizes.width = getViewportWidth();

	for (let bp in hpy_sizes.breakpoints) {
		hpy_sizes.breakpoints[bp].min = hpy_sizes.width >= hpy_sizes.breakpoints[bp].bp ? true : false;
		hpy_sizes.breakpoints[bp].max = hpy_sizes.width < hpy_sizes.breakpoints[bp].bp ? true : false;
	}
}

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 */
export function skipLinkFocus() {
	let isWebkit = navigator.userAgent.toLowerCase().indexOf('webkit') > -1;
	let isOpera = navigator.userAgent.toLowerCase().indexOf('opera') > -1;
	let isIe = navigator.userAgent.toLowerCase().indexOf('msie') > -1;

	if ((isWebkit || isOpera || isIe) && document.getElementById && window.addEventListener) {
		window.addEventListener(
			'hashchange',
			function () {
				let id = location.hash.substring(1),
					element;

				if (!(/^[A-z0-9_-]+$/.test(id))) {
					return;
				}

				element = document.getElementById(id);

				if (element) {
					if (!(/^(?:a|select|input|button|textarea)$/i.test(element.tagName))) {
						element.tabIndex = -1;
					}

					element.focus();
				}
			},
			false
		);
	}
}

export function mergeObject(obj, defaultObj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			// Push each value from `obj` into `extended`
			defaultObj[prop] = obj[prop];
		}
	}

	return defaultObj;
}

export function attachEventToBody(element, callbackFn, _this = '') {
	document.getElementsByTagName('body')[0].addEventListener(
		'click',
		(event) => {
			for (let el of document.querySelectorAll(element)) {
				if (el.contains(event.target)) {
					callbackFn(el, _this);
				}
			}
		}
	)
}

export function createElementFromString(string) {
	const element = new DOMParser().parseFromString(string, 'text/html');
	return element.body.childNodes[0];
}

export function clear(element) {
	while (element.firstChild) {
		element.removeChild(element.lastChild);
	}
}